import { render, staticRenderFns } from "./ComponentAlertInfo.vue?vue&type=template&id=65a3ad8c&scoped=true"
import script from "./ComponentAlertInfo.vue?vue&type=script&lang=js"
export * from "./ComponentAlertInfo.vue?vue&type=script&lang=js"
import style0 from "./ComponentAlertInfo.vue?vue&type=style&index=0&id=65a3ad8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a3ad8c",
  null
  
)

export default component.exports